module.exports = __webpack_public_path__ + "r-v3/img/pointer_gray.4468c30a.svg";